import type { PLAN_PRO, PLAN_TEAM } from '@/constants/userSubscriptionPlans'

export enum PERMISSION_TYPE {
  YES = 'YES', // The feature is fully available.
  NO = 'NO', // The feature is not displayed.
  NA = 'NA', // The feature is not available, displayed as inactive.
  LIMITED = 'LIMITED', // The feature is available with limitations.
  NA_BADGE = 'NA_BADGE', // The feature is not available, it is displayed as inactive with a badge indicating from which plan it becomes available.
}

export type PERMISSION_VALUE = {
  type: PERMISSION_TYPE
  badge?: typeof PLAN_PRO | typeof PLAN_TEAM
}

export function getPermissionsMatrixByUserType<
  T extends string | number | symbol,
  P extends string | number | symbol,
>(
  userType: T,
  PermissionsMatrix: Record<P, Record<T, PERMISSION_VALUE>>
): Record<P, PERMISSION_VALUE> | null {
  const permissions = Object.keys(PermissionsMatrix).reduce(
    (res, permission) => {
      if (
        PermissionsMatrix[permission as P] &&
        PermissionsMatrix[permission as P][userType]
      ) {
        return {
          ...res,
          [permission]: PermissionsMatrix[permission as P][userType],
        }
      }

      return res
    },
    {} as Record<P, PERMISSION_VALUE>
  )

  return Object.keys(permissions).length > 0 ? permissions : null
}
